import React, { useMemo } from "react";
import { View } from "react-native";
import { QuestionTitle } from "../questionTitlte/QuestionTitle";
import { style as hostDefaultQuestionItemStyle } from "./HostDefaultQuestionItem.style";
const HostDefaultQuestionItem = ({ domain, question, level, children, segment, }) => {
    const style = useMemo(() => hostDefaultQuestionItemStyle(), []);
    return (React.createElement(View, { style: style.container, testID: "host-default-question-item" },
        question.translationKey && (React.createElement(QuestionTitle, { domain: domain, level: level, segment: segment, translationKey: question.translationKey })),
        children));
};
export { HostDefaultQuestionItem };
